import { $http } from "@/assets/js/appFunc"; // eslint-disable-line

export const actSystemUsersApi = (context) => {
    const req = {
        type: "GET",
        url: "/integration/ws/collections"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(data => {
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const actSystemUsersApiOnSearch = (context, searchValue) => {
    const req = {
        type: "GET",
        url: `/integration/ws/collections?filter=${searchValue}`
    };
    return $http(req, true);
};

export const actGetSystemApisMethod = (context, payload) => {
    const { processDefinitionId, categoryId } = payload;
    const processDefinitionData = processDefinitionId ? `applicationId=${processDefinitionId}&` : "";
    const versionId = context.rootGetters["version/latestVersionId"];
    const req = {
        type: "GET",
        url: `/integration/ws/system/categories/apis/by/application?${processDefinitionData}categoryId=${categoryId}&versionId=${versionId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(data => {
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const actSaveDeleteSystemApis = (context, payload) => {
    const versionId = context.rootGetters["version/latestVersionId"];
    const { processDefinitionId, wsIds, categoryId } = payload;
    const processDefinitionData = processDefinitionId ? `applicationId=${processDefinitionId}&` : "";
    const req = {
        type: "POST",
        url: `/integration/ws/system/categories/apis/application?${processDefinitionData}versionId=${versionId}&categoryId=${categoryId}`,
        data: wsIds
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(data => {
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const downloadSystemApisLogs = (store, categoryName) => new Promise(() => {
    $http({
        url: `/audit/logs/systemApis?category=${categoryName}`,
        type: "GET",
        responseType: "arraybuffer",
        headers: {
            "Content-type": "application/json;charset=UTF-8",
            Accept: "application/octet-stream"
        }
    }, true).then(rsp => {
        const url = window.URL.createObjectURL(new Blob([rsp.data], { type: "application/octet-stream" }));
        const link = document.createElement("a");
        link.href = url;
        // eslint-disable-next-line prefer-destructuring
        link.download = rsp.headers["content-disposition"].split("=")[1];
        document.body.appendChild(link);
        link.click();
    }).catch(e => {
        console.log(e);
    });
});
